import Markdown from "@components/Markdown";
import { Button, createStyles, makeStyles, useTheme } from "@material-ui/core";
import settings from "@styles/settings";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
    },
    icon: {
      width: "20px",
    },
    headerBlocks: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      height: "5px",
    },
    headerBlock: {
      flex: "1 1",
      margin: "0",
      // paddingTop: "4px",
    },
    headerBlock1: {
      backgroundColor: "#2d5f9f",
    },
    headerBlock2: {
      backgroundColor: "#3470b4",
    },
    headerBlock3: {
      backgroundColor: "#3a9bd5",
    },
    headerBlock4: {
      backgroundColor: "#3bace1",
    },
    headerBlock5: {
      backgroundColor: "#de1077",
    },
    headerBlock6: {
      backgroundColor: "#ef6750",
    },
    headerBlock7: {
      backgroundColor: "#ffcf30",
    },
  })
);

export default function DisclaimerPreview(props: {
  text: string;
  buttonText: string;
  setDisclaimerModalOpen: any;
}) {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <div style={{ height: `calc(${settings.navigationButtonsBarHeight} - 5px)` }}>
      <div className={classes.headerBlocks}>
        <div className={`${classes.headerBlock} ${classes.headerBlock1}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock2}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock3}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock4}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock5}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock6}`} />
        <div className={`${classes.headerBlock} ${classes.headerBlock7}`} />
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "transparent",
          padding: theme.spacing(2),
          display: "flex",
          textAlign: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Markdown style={{ ...theme.typography.subtitle2 }}>{props.text}</Markdown>
        <Button
          onClick={() => {
            props.setDisclaimerModalOpen(true);
          }}
          style={{ color: theme.palette.primary.light, minWidth: "150px" }}
        >
          {props.buttonText}
        </Button>
      </div>
    </div>
  );
}
